import flatpickr from "flatpickr";
import { Controller } from "@hotwired/stimulus"
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default class extends Controller {
  connect() {
    this.flatpickrInstance = flatpickr(this.element, {
      locale: Spanish,
      dateFormat: "d/m/Y",
      allowInput: true,
      clickOpens: true,
      onChange: (selectedDates, dateStr, instance) => {
        // Actualizar el valor del input con el formato d/m/Y para mostrar
        this.element.value = dateStr;

        // Agregar input hidden si es para date_of_issue (formulario de facturas) o order_for_date (orden de compra)
        if (this.element.name && (this.element.name.includes('[date_of_issue]') || this.element.name.includes('[order_for_date]'))) {
          if (selectedDates[0]) {
            // formatDate de flatpickr usa la fecha local. toISOString() la pasaba a
            // UTC: en Argentina daba bien de casualidad (medianoche local = 03:00 UTC).
            const isoDate = instance.formatDate(selectedDates[0], "Y-m-d");
            let hiddenInputName;
            if (this.element.name.includes('[date_of_issue]')) {
              hiddenInputName = this.element.name.replace('[date_of_issue]', '[date_of_issue_iso]');
            } else if (this.element.name.includes('[order_for_date]')) {
              hiddenInputName = this.element.name.replace('[order_for_date]', '[order_for_date_iso]');
            }
            // Remover el input hidden anterior si existe
            const existingHidden = this.element.parentElement.querySelector(`input[name="${hiddenInputName}"]`);
            if (existingHidden) {
              existingHidden.remove();
            }
            // Crear y agregar el nuevo input hidden
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = hiddenInputName;
            hiddenInput.value = isoDate;
            this.element.parentElement.appendChild(hiddenInput);
          }
        }
      }
    });
  }

  disconnect() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
  }
}
